import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

let IP = environment.apiUrl;
let http_type = environment.apiType;
let apiv2 = '/api/v2/';

@Injectable({ providedIn: 'root' })
export class HttpRequestsService<T> {
  private filesURL =  http_type + '://' + IP + apiv2 + 'files';

  private citiesURL = http_type + '://' + IP + apiv2 + 'cities';

  private dnaURL = http_type + '://' + IP + apiv2 + 'dna';

  private contentByCityURL = http_type + '://' + IP + apiv2 + 'citysdata?city=';

  private dataByContentIdURL = http_type + '://' + IP + apiv2 + 'getinfo?info=';

  private contentURL = http_type + '://' + IP + apiv2 + 'update?';

  private evaluationURL = http_type + '://' + IP + apiv2 + 'evaluation';

  private templateURL = http_type + '://' + IP + apiv2 + 'kpis_eval';

  private meta_lqURL = http_type + '://' + IP + apiv2 + 'meta';

  private actionsURL = http_type + '://' + IP + apiv2 + 'actions';

  private descriptionsUrl = http_type + '://' + IP + apiv2 + 'descriptions';
  
  private mediaUrl = http_type + '://' + IP + apiv2 + 'media';

  private objectivesUrl = http_type + '://' + IP + apiv2 + 'objectives';

  private impactsUrl = http_type + '://' + IP + apiv2 + 'impacts';

  constructor(private http: HttpClient) { }

  // GET REQUESTS==================================================================================

  getAllFiles(): Observable<T> {
    return this.http.get<T>(this.filesURL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getDocument(id): Observable<T> {
    let URL = this.filesURL + '?file_id=' + id;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getUnpublishedDocs(): Observable<T> {
    let URL =
      this.filesURL + '?fileStatus=' + 'UN_PUBLISHED';
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getDocuments(keyword): Observable<T> {
    let URL =
      this.filesURL + '?searching_word=' + keyword;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getLocations() {
    return this.http.get<T>(this.filesURL + '?locations=true').pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getCities(): Observable<T> {
    return this.http.get<T>(this.citiesURL).pipe(
      map((data: any) => data.map(({ Video, Email, City, Country, Code, Description, Baseline_score, M24_score, M36_score, M42_score, Comittee, Mission, Objectives, Orientation, Target_groups, Info, Impacts }) => ({ Video, Email, City, Country, Code, Description, Baseline_score, M24_score, M36_score, M42_score, Comittee, Mission, Objectives, Orientation, Target_groups, Info, Impacts })))
    )
  }

  getCityDna(city: string): Observable<T> {
    let URL = this.dnaURL + '?city=' + city;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Action_Cat, Action, Nutrition, Climate, Circularity, Innovation }) => ({ Action_Cat, Action, Nutrition, Climate, Circularity, Innovation })))
    )
  }

  getCityCount(city: string): Observable<T> {
    let URL = this.dnaURL + '?city=' + city + '&count=True';
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Circularity, Climate, Distribution, Governance, Innovation, Kpis, Nutrition, Production, Social, Sustainable, Waste, Advocacy }) => ({ Circularity, Climate, Distribution, Governance, Innovation, Kpis, Nutrition, Production, Social, Sustainable, Waste, Advocacy })))
    )
  }

  getGlobalPriorities(): Observable<T> {
    let URL = this.dnaURL + '?priorities=true';
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Circularity, Climate, Innovation, Nutrition }) => ({ Circularity, Climate, Innovation, Nutrition })))
    )
  }

  getCityPriorities(city: string): Observable<T> {
    let URL = this.dnaURL + '?priorities=true' + '&city=' + city;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Circularity, Climate, Innovation, Nutrition }) => ({ Circularity, Climate, Innovation, Nutrition })))
    )
  }

  getMetas(): Observable<T> {
    return this.http.get<T>(this.meta_lqURL).pipe(
      map((data: any) => data.data.map(({ Meta_LQ, ID, LQ }) => ({ Meta_LQ, ID, LQ })))
    )
  }

  getAllMetas(): Observable<T> {
    return this.http.get<T>(this.meta_lqURL).pipe(
      map((data: any) => data.data.map(({ Meta }) => ({ Meta })))
    )
  }

  getAllQuestions(meta: string): Observable<T> {
    let URL = this.meta_lqURL + '?metalq=' + meta;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ LQ }) => ({ LQ })))
    )
  }

  getCitiesofQuestions(question: string): Observable<T> {
    let URL = this.meta_lqURL + '?lq=' + question;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ City }) => ({ City })))
    )
  }

  getAllActionCategories(): Observable<T> {
    let URL = this.actionsURL;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getAllActions(category: string): Observable<T> {
    let URL = this.actionsURL + '?actioncat=' + category;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ Action }) => ({ Action })))
    )
  }

  getCitiesofActions(action: string): Observable<T> {
    let URL = this.actionsURL + '?action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ City }) => ({ City })))
    )
  }

  getActions(id: string): Observable<T> {
    let URL = this.actionsURL + '?action_cat_id=' + id;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getCitiesLQs(city: string): Observable<T> {
    let URL = this.contentByCityURL + city;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Activities, Date, ID, LQ }) => ({ Activities, Date, ID, LQ })))
    );
  }

  getLQData(id: string): Observable<T> {
    let URL = this.dataByContentIdURL + id + '&rq=lq';
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Meta, LQ, Summ, Cities1, Cities2, Meta_LQ, Activities }) => ({ Meta, LQ, Summ, Cities1, Cities2, Meta_LQ, Activities })))
    );
  }

  getActivityData(activity: string, city: string): Observable<T> {
    let URL = this.dataByContentIdURL + activity + '&city=' + city;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Act, Actions, Cities, LQ, Summ }) => ({ Act, Actions, Cities, LQ, Summ })))
    );
  }

  getEvaluation(): Observable<T> {
    return this.http.get<T>(this.evaluationURL).pipe(
      map((data: any) => data.map(({ Kpi_Cat, Kpis }) => ({ Kpi_Cat, Kpis })))
    )
  }

  getCityEvaluationActions(city: string): Observable<T> {
    let URL = this.evaluationURL + '?city=' + city + '&kpi_cat=False';
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Action_Cat, Actions }) => ({ Action_Cat, Actions })))
    );
  }

  getCityEvaluationKpis(city: string): Observable<T> {
    let URL = this.evaluationURL + '?city=' + city + '&kpi_cat=True';
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Kpi_Cat, Kpis }) => ({ Kpi_Cat, Kpis })))
    );
  }

  getCityActionEvaluation(city: string, action: string): Observable<T> {
    let URL = this.evaluationURL + '?city=' + city + '&action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ Kpi }) => ({ Kpi })))
    );
  }

  getCityActionEvaluationDescription(city: string, action: string): Observable<T> {
    let URL = this.descriptionsUrl + '?city=' + city + '&action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Description }) => ({ Description })))
    );
  }

  getCityActionEvaluationObjective(city: string, action: string): Observable<T> {
    let URL = this.objectivesUrl + '?city=' + city + '&action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Objective }) => ({ Objective })))
    );
  }

  getCityActionEvaluationMedia(city: string, action: string): Observable<T> {
    let URL = this.mediaUrl + '?city=' + city + '&action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Media }) => ({ Media })))
    );
  }

  getCityKpiActions(city: string, kpi: string): Observable<T> {
    let URL = this.evaluationURL + '?city=' + city + '&kpi=' + kpi;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.data.map(({ Actions }) => ({ Actions })))
    );
  }

  getKpiActionEvaluationScore(city: string, kpi: string, action: string): Observable<T> {
    let URL = this.evaluationURL + '?city=' + city + '&kpi=' + kpi + '&action=' + action;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ Baseline_score, M24_score, M36_score, M48_score, Keys, Info }) => ({ Baseline_score, M24_score, M36_score, M48_score, Keys, Info })))
    );
  }

  getEvaluationQuestionnaire(step: string): Observable<T> {
    let URL = this.evaluationURL + '?step=' + step;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ LQs, Tag }) => ({ LQs, Tag })))
    );
  }

  getKpiTemplate(kpi: string): Observable<T> {
    let URL = this.templateURL + '?kpi=' + kpi;
    return this.http.get<T>(URL).pipe(
      map((data: any) => data.map(({ answers, criteria, max_score, question, kpi_name }) => ({ answers, criteria, max_score, question, kpi_name })))
    );
  }

  getImpacts(): Observable<T> {
    let URL = this.impactsUrl + '?city=project' ;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getCityImpacts(city: string): Observable<T> {
    let URL = this.impactsUrl + '?city=' + city;
   return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  getCitiesByKpi(kpi: string): Observable<T> {
    let URL = this.evaluationURL + '?cities_by_kpi=True' + '&kpi=' + kpi;
    return this.http.get<T>(URL).pipe(
      tap((Data) => { }),
      catchError((err) => {
        throw err;
      })
    );
  }

  // PATCH REQUESTS==================================================================================

  publishDocument(id, data) {
    let _URL = this.filesURL + '?file_id=' + id + '&fileStatus=PUBLISHED';
    return this.http.patch(_URL, data).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  rejectDocument(id, data) {
    let _URL = this.filesURL + '?file_id=' + id + '&fileStatus=REJECT';
    return this.http.patch(_URL, data).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  updateContent(id, data) {
    let _URL = this.contentURL + 'id=' + id + '&summ=' + data;
    return this.http.patch(_URL, data).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  updateDNA(city, data) {
    let _URL = this.citiesURL + '?city=' + city;
    return this.http.patch(_URL, data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  // POST REQUESTS==================================================================================

  postDocument(data) {
    return this.http.post(this.filesURL, data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  postContent(data, type) {
    let _URL = this.contentURL + 'data=' + data + '&rq=' + type;
    return this.http.post(_URL, data, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  updateDescription(city, action, description) {
    let _URL = this.descriptionsUrl + '?city=' + city + '&action=' + action;
    return this.http.post(_URL, description, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  updateObjective(city, action, objective) {
    let _URL = this.objectivesUrl + '?city=' + city + '&action=' + action;
    return this.http.post(_URL, objective, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  updateMedia(city, action, media) {
    let _URL = this.mediaUrl + '?city=' + city + '&action=' + action;
    return this.http.post(_URL, media, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' }).pipe(
      tap((res) => { }),
      catchError((err) => {
        console.log(err);
        throw err;
      })
    );
  }

  // DELETE REQUESTS===============================================================================

  deleteContent(id): Observable<T> {
    let _URL = this.contentURL + 'id=' + id;
    return this.http.delete<T>(_URL);
  }
}